import React from "react";
import { connect } from "react-redux";
import * as R from "ramda";
import CSSModules from "react-css-modules";
import { actions } from "../model";
import { getCurrentForm } from "../selectors";
import CalculatedNumber from "components/Global/Table3/ModalColumn/CalculatedNumberSettings";
import { noop } from "utils/General";
import css from "./style.scss";

const decorate = R.compose(
  connect(
    (state, props) => {
      const form = getCurrentForm(state, props);
      return {
        calculatedNumberSettings: R.pathOr(
          {
            calculatedNumberExpression: "",
            readOnly: true
          },
          ["calculatedNumberSettings"],
          form
        ),
        fields: R.pathOr([], ["fields"], form)
      };
    },
    (dispatch, props) => ({
      setCalculatedNumberSettings: settings =>
        dispatch(
          actions.updateSettings({
            index: props.formIndex,
            key: "calculatedNumberSettings",
            settings
          })
        )
    })
  ),
  CSSModules(css)
);

const CalculatedNumberSettings = ({
  calculatedNumberSettings,
  setCalculatedNumberSettings = noop,
  fields
}) => (
  <div styleName="dropdownOptionsWrapper">
    <CalculatedNumber
      columns={fields}
      value={calculatedNumberSettings}
      onChange={setCalculatedNumberSettings}
    />
  </div>
);

export default decorate(CalculatedNumberSettings);
